//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        result: {
            type: String,
            default: ''
        },
        instructions: {
            type: Array,
            default: () => ([])
        },
        highlightInstructionIndex: {
            type: Array,
            default: () => ([])
        }
    },

    data () {
        return {
            showSkipScreen: false,
            showPauseCockpitScreen: false,
            showPauseFinishedCockpitScreen: false,
            showPauseHelpScreen: false,
            items: [
                {
                    name: 'continue',
                    tooltip: this.$lang.get('partials.status.stop'),
                    visible: !this.$store.getters.hasUserFinishedWeek(this.$route.meta.week) && this.$route.name.includes('game'),
                    pointerdown: () => {
                        this.showSkipScreen = true;
                    }
                },
                {
                    name: 'help',
                    tooltip: this.$lang.get('partials.status.help'),
                    visible: !this.$store.getters.hasUserFinishedWeek(this.$route.meta.week),
                    pointerdown: () => {
                        this.showPauseHelpScreen = true;
                    }
                },
                {
                    name: 'cockpit',
                    tooltip: this.$lang.get('partials.status.back'),
                    visible: true,
                    pointerdown: () => {
                        if (!this.$store.getters.hasUserFinishedWeek(this.$route.meta.week)) {
                            this.showPauseCockpitScreen = true;
                        } else {
                            this.showPauseFinishedCockpitScreen = true;
                        }
                    }
                }
            ]
        };
    },

    computed: {
        stars () {
            return this.$store.getters.stars;
        },
        visibleItems () {
            return this.items.filter(item => item.visible);
        }
    }
};
